import React from "react";

function YouTubeEmbed({ videoId }) {
  if (!videoId) return null;
  const src = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`;
  return (
    <iframe
      src={src}
      title="YouTube video"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      style={{ width: "100%", height: "100%", border: 0 }}
    />
  );
}

export default YouTubeEmbed;

